<template>
      <app-layout>
        <template v-slot:adminnav >
  </template>
  <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mt-3">
        <p class="font-semibold text-lg text-gray-800 leading-tight"> Org Profile </p>
        <p class=" text-xs">We’re updating the cards and ranking all the time, so check back regularly.</p>
      </div>

 <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 ">
      <div class="w-full">
        <div class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
            
          <div class="text-lg font-bold mb-2">Update Organisation Info</div> 

            <form @submit.prevent="update">
              <BsEdit :createDef="createDef" :routeDef="moduleRoute" :modelData="modelData" ref="formRenderer"> </BsEdit>

              <div class="px-4 py-3  text-right sm:px-6">
              <jet-button type="submit" @click="update" class="bg-blue-500 rounded text-sm pl-2 pr-2 pt-1 pb-1 text-white hover:bg-blue-700 hover:no-underline"> Update </jet-button>
            </div>     
              </form>




        </div>
      </div>
    </div>
 
  </app-layout>

 
</template>
<script>  
import JetNavLink from '@/Jetstream/NavLink.vue';
import AppLayout from '@/Layouts/AppLayout.vue';

//import AppLayout from "@/Layouts/AppLayout.vue";
import BsEdit from "@/Base/BsEdit.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import DxTextBox from 'devextreme-vue/text-box';
import { DxToast } from 'devextreme-vue/toast';

import {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
} from 'devextreme-vue/form';
const modelData = {};
export default {
  props: {
  createDef: Array,
    moduleRoute: String,
    moduleName:  String,
    slug:String,
    modelData:{
        type: Object,
        default: () => ({})
    },
    
  },
  components: {
    AppLayout,
    BsEdit,
    PageTitle,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxTextBox,
    JetNavLink,
    DxToast,
    
  },
  data: function () {
    return {
    
    };
  },
  methods: {
    update()
    {
        
      //console.log(this.$refs.formRenderer.formData);
      this.$refs.formRenderer.formData.route_slug = this.slug
      //{ id: 1, name: 'Jacob' }
       this.$inertia.put(route('tenant-admin-panels.orgupdate',{id:this.modelData.id,route_slug:this.slug}),this.$refs.formRenderer.formData)

    //   this.$inertia.put(route('tenant-admin-panels.orgupdate',this.modelData.id),this.$refs.formRenderer.formData)
        
    }  
    
  },
  mounted() {

     
  },


};
</script>
<style>
.main-content {
background-color: #F3F4F6;
  /* width: calc(100% - 250px); */
  /* height: 100vh; */
  margin-left: 212px;
  padding: 10px;
}
@media only screen and (max-width: 420px){
  .main-content {
      width: 100%;
      margin-left: 0;
      z-index: -1;
      position: relative;
  }
}
@media only screen and (max-width: 768px){
  .main-content {
      width: 100%;
      margin-left: 0;
      z-index: -1;
      position: relative;
  }
}
</style>